"use client";

/** Main page header */
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import { GLOBAL_ALERT_HEIGHT } from "../GlobalAlert";
import Link from "../tailwind/Link";

import { Logo } from "~~/app/common";
import { useStatus } from "~~/app/hooks/useStatus";
export interface Props {
  showConnectWallet?: boolean;
  zIndex?: number;
}

export const MainPageHeader = ({ zIndex }: Props): JSX.Element => {
  const { status } = useStatus();

  const pathname = usePathname();
  const isHomePage = pathname === "/";

  const [scrollStopped, setScrollStopped] = useState<boolean>(false);

  const handleScroll = (): void => {
    if (window.scrollY > 20) {
      setScrollStopped(true);
    } else {
      setScrollStopped(false);
    }
  };

  const getHeaderBg = () => {
    if (!scrollStopped) {
      return "transparent";
    }

    if (isHomePage) {
      return "#2B0928";
    }

    return "#07264D";
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const logo = (
    <div
      className="flex justify-center pl-4 md:pl-0 flex-[3] sm:flex-[1.75] md:flex-[1.6] lg:flex-[1] xl:flex-[1] 2xl:flex-[1]"
      style={{ zIndex: zIndex }}
    >
      <div className="flex items-center flex-row gap-2">
        <Link
          analyticsId="click logo"
          analyticsProps={{
            where: "header",
          }}
          href="/#"
          className="mr-6"
        >
          <Logo className="max-w-[80px] md:max-w-[160px]" />
        </Link>
      </div>
    </div>
  );

  const headerBg = getHeaderBg();

  return (
    <div
      className="flex flex-row justify-between items-center py-4 px-3 md:px-24 fixed left-0 right-0 z-[9] w-screen flex-1"
      style={{
        background: headerBg,
        borderBottom: scrollStopped
          ? "1px solid rgba(255, 255, 255, 0.1)"
          : "none",
        top: !status ? 0 : `${GLOBAL_ALERT_HEIGHT}px`,
        transition: "background 100ms ease-in",
      }}
    >
      <div className="flex flex-row items-center justify-between w-full">
        {logo}
      </div>
    </div>
  );
};
